import React, { useContext } from 'react'
import Modal from 'modules/react/signup/Modal'
import RightContent from 'modules/react/signup/RightContent'
import LeftContent from 'modules/react/signup/LeftContent'
import SignupContext from 'modules/react/signup/SignupContext'
import WhenStep from 'modules/react/signup/conditionals/WhenStep'
import FormElementError from 'modules/react/signup/FormElementError'
import SignupCompleted from 'modules/react/signup/without-dates/SignupCompleted'
import Step1RightContent from 'modules/react/signup/without-dates/Step1RightContent'
import NewsletterCheckbox from 'modules/react/signup/NewsletterCheckbox'

export default function SignupContent () {
  const signupContext = useContext(SignupContext)

  const {
    cleanUp,
    setModal,
    setFormValue,
    submit,
    goToNextStep,
    modal,
    restUrls,
    buttonText,
    setEnterCallback
  } = signupContext

  React.useEffect(() => {
      setEnterCallback(() => completeSignup)
    }, []
  )

  const modalRef = React.createRef()

  React.useEffect(() => {
    setModal(modalRef?.current)
  }, [modalRef?.current])

  const completeSignup = () => {
    submit(restUrls.signup)
      .then((response) => {
        goToNextStep()
      })
  }

  React.useEffect(() => {
    modal?.addClass('signup-modal--larger-form')

    return () => modal?.removeClass('signup-modal--larger-form')
  }, [modal])

  return (
    <>
      <button className="button button--full-width"
              onClick={() => modalRef.current.open()}>{buttonText ? buttonText : 'Skriv mig op'}</button>
      <Modal ref={modalRef} onCloseCallback={cleanUp}>
        <WhenStep is={1}>
          <LeftContent>
            <div className="title title--h3">Tilmelding dig ventelisten</div>
            <div className="title title--h6">Udfyld dine oplysninger</div>
            <div className="input-group">
              <div className="input-group__half">
                <div className="input-wrap">
                  <FormElementError name="firstName">
                    <input type="text" placeholder="Dit fornavn:" onChange={(e) => setFormValue('firstName', e.target.value)}/>
                  </FormElementError>
                </div>
                <div className="input-wrap">
                  <FormElementError name="lastName">
                    <input type="text" placeholder="Dit efternavn:" onChange={(e) => setFormValue('lastName', e.target.value)}/>
                  </FormElementError>
                </div>
              </div>
              <div className="input-wrap">
                <FormElementError name="email">
                  <input type="text" placeholder="Din email:"
                         onChange={(e) => setFormValue('email', e.target.value.trim())}/>
                </FormElementError>
              </div>
            </div>
            <NewsletterCheckbox/>
            <div className="button-section button-section--modal-group">
              <button className="button button--next" onClick={completeSignup}>
                Tilmeld til venteliste
              </button>
            </div>
          </LeftContent>
          <RightContent>
            <Step1RightContent/>
          </RightContent>
        </WhenStep>
        <WhenStep is={2}>
          <SignupCompleted/>
        </WhenStep>
      </Modal>
    </>
  )
}